import { useCallback } from 'react';

import useTranslation from '../../../hooks/useTranslation';
import TranslationsConfigType from '../../../translations/translationType';
import { UseValidateHook } from '../../../utils/validation/validateTypes';
import validateForm from '../../transaction/Payment/SelectReceiver/validateForm';
import { ReceiverDetailsState } from './state';

export type ReceiverDetailsError = {
    accountNumber?: string;
    accountName?: string;
};

const validate =
    (translated: TranslationsConfigType) =>
    (formState: ReceiverDetailsState): ReceiverDetailsError => {
        const { accountNumber, accountName } = formState;

        const validationMessages = validateForm({
            accountNumber,
            accountName,
            translated,
            isInPaymentContext: false,
        });

        return {
            accountNumber: validationMessages.accountNumberInput,
            accountName: validationMessages.accountNameInput,
        };
    };

const useValidate: UseValidateHook<ReceiverDetailsState, ReceiverDetailsError> = () => {
    const translated = useTranslation();
    return useCallback(async (state) => validate(translated)(state), [translated]);
};

export default useValidate;
